import { useEffect, useState, useCallback } from 'react';
import { Box, Card, CardContent, CardActionArea, Badge, Typography, Grid } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { fetchAuthSession } from 'aws-amplify/auth';

import {
  fetchUnreadCountByPatientId,
  subscribeToNewNotificationsByPatientId,
  subscribeToUpdatedNotificationsByPatientId
} from '../../InAppNotification/services/apiService';

interface NotificationIconCardProps {
  title: string;
  onClick: () => void;
  rotate?: number;
  size?: number;
}

// 未読数取得関数
const fetchUnreadCount = async (patientId: string): Promise<number> => {
  return await fetchUnreadCountByPatientId(patientId);
};

const NotificationIconCard = ({ title, onClick, rotate = 0, size = 40 }: NotificationIconCardProps) => {
  const [unreadCount, setUnreadCount] = useState<number>(0);

  const updateUnreadCount = useCallback(async () => {
    const session = await fetchAuthSession();
    const patientId = session?.userSub;
    if (patientId) {
      const count = await fetchUnreadCount(patientId);
      setUnreadCount(count);
    }
  }, []);

  useEffect(() => {
    updateUnreadCount();

    const subscribeToNotifications = async () => {
      const session = await fetchAuthSession();
      const patientId = session?.userSub;

      if (patientId) {
        const newNotificationSub = subscribeToNewNotificationsByPatientId(patientId, updateUnreadCount, (error) =>
          console.error('New Notification Subscription Error:', error)
        );
        const updatedNotificationSub = subscribeToUpdatedNotificationsByPatientId(
          patientId,
          updateUnreadCount,
          (error) => console.error('Updated Notification Subscription Error:', error)
        );
        return () => {
          newNotificationSub.unsubscribe();
          updatedNotificationSub.unsubscribe();
        };
      }
    };

    subscribeToNotifications();
  }, [updateUnreadCount]);

  return (
    <Card variant="outlined">
      <CardActionArea onClick={onClick}>
        <CardContent sx={{ padding: '8px !important', position: 'relative' }}>
          <Badge
            variant="dot"
            color="error"
            invisible={unreadCount === 0} // 未読がなければ赤丸を非表示
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            sx={{
              position: 'absolute',
              top: '8px',
              left: '8px',
              transform: 'translate(50%, -50%)',
              '& .MuiBadge-dot': {
                width: '10px',
                height: '10px'
              }
            }}
          />
          <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'} m={1}>
            <Box display="flex" alignItems="center" mr={'auto'} zIndex={1}>
              <Typography className="font-bold" mr={1}>
                {title}
              </Typography>
            </Box>
            <Grid
              m={0.5}
              py={'auto'}
              right={0}
              position={'absolute'}
              sx={{ opacity: 0.3, transform: `rotate(${rotate}deg)` }}
            >
              <NotificationsIcon sx={{ color: '#A08B64', fontSize: size }} />
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default NotificationIconCard;
